/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Challenge request workflow states. Match lifecycle tracked separately.
 * @export
 */
export const LadderChallengeStatus = {
    PENDING: 'PENDING',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED',
    CANCELLED: 'CANCELLED'
} as const;
export type LadderChallengeStatus = typeof LadderChallengeStatus[keyof typeof LadderChallengeStatus];


export function instanceOfLadderChallengeStatus(value: any): boolean {
    for (const key in LadderChallengeStatus) {
        if (Object.prototype.hasOwnProperty.call(LadderChallengeStatus, key)) {
            if (LadderChallengeStatus[key as keyof typeof LadderChallengeStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LadderChallengeStatusFromJSON(json: any): LadderChallengeStatus {
    return LadderChallengeStatusFromJSONTyped(json, false);
}

export function LadderChallengeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LadderChallengeStatus {
    return json as LadderChallengeStatus;
}

export function LadderChallengeStatusToJSON(value?: LadderChallengeStatus | null): any {
    return value as any;
}

export function LadderChallengeStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): LadderChallengeStatus {
    return value as LadderChallengeStatus;
}

